import "./TripStyles.css";
import TripData from "./TripData";
import Trip1 from "../assets/5.jpg";
import Trip2 from "../assets/8.jpg";
import Trip3 from "../assets/6.jpg";

function Trip() {
  return (
    <div className="trip">
      <h1>Recent Trips.</h1>
      <p>You can discover unique destinations using Google Maps</p>
      <div className="tripcard">
        <TripData
          image={Trip1}
          heading="Trip to Indonesia"
          text="Lorem ipsum dolor sit, amet consectetur adipisicing elit. Similique exercitationem totam quae, laborum accusantium nemo assumenda eum in maxime excepturi impedit facilis nam cupiditate molestias aut vero inventore. Ducimus, non?"
        />

        <TripData
          image={Trip2}
          heading="Trip to Malaysia"
          text="Lorem ipsum dolor sit, amet consectetur adipisicing elit. Similique exercitationem totam quae, laborum accusantium nemo assumenda eum in maxime excepturi impedit facilis nam cupiditate molestias aut vero inventore. Ducimus, non?"
        />

        <TripData
          image={Trip3}
          heading="Trip to Italy"
          text="Lorem ipsum dolor sit, amet consectetur adipisicing elit. Similique exercitationem totam quae, laborum accusantium nemo assumenda eum in maxime excepturi impedit facilis nam cupiditate molestias aut vero inventore. Ducimus, non?"
        />
      </div>
    </div>
  );
}

export default Trip;
